/* PAPELINE — composeur du hero + révélation au défilement.
   Idempotent : peut être ré-exécuté par l'éditeur de thème. */
(function () {
  'use strict';

  function initComposer(root) {
    if (root.dataset.plInit === '1') return;
    root.dataset.plInit = '1';

    var chips = Array.prototype.slice.call(root.querySelectorAll('.pl-chip'));
    var readout = root.querySelector('.pl-readout');
    if (!chips.length) return;

    var perTheme = parseInt(root.dataset.pagesPerTheme, 10) || 6;
    var unit = parseFloat(root.dataset.unitPrice) || 0.9;
    var fmt;
    try {
      fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' \u20ac'; } };
    }

    function sync() {
      if (!readout) return;
      var on = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
      if (!on.length) {
        readout.innerHTML = readout.dataset.empty || 'Choisis au moins un th\u00e8me.';
        return;
      }
      var pages = on.length * perTheme;
      readout.innerHTML = '<b>' + pages + ' pages</b> \u00b7 ' + on.length + ' th\u00e8me' +
        (on.length > 1 ? 's' : '') + ' \u00b7 \u00e0 partir de <b>' + fmt.format(pages * unit) +
        '</b> hors classeur';
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var next = chip.getAttribute('aria-pressed') !== 'true';
        chip.setAttribute('aria-pressed', String(next));
        var sheet = root.querySelector('.pl-sheet[data-theme="' + chip.dataset.target + '"]');
        if (sheet) sheet.dataset.on = String(next);
        sync();
      });
    });

    sync();
  }

  function initReveal(scope) {
    var targets = scope.querySelectorAll('.pl [data-rev]:not(.is-in)');
    if (!targets.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
  }

  function boot(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-pl-composer]'), initComposer);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // L'éditeur de thème recharge les sections : on réinitialise.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
